import React from 'react';
import { jsx, css } from '@emotion/core';

import Arrow from '../Icons/Arrow';

const SlickButtonFix = ({
  primaryColor,
  uiVariant,
  children,
  sliderCircleArrowsBanner,
  circularCarouselSymptomsVersion,
  secondaryColor,

  props,
}) => {
  const BasicArrowStyle = css`
    color: #7b7b7b;
    z-index: 1000;

    &.slick-prev {
      svg {
        transform: rotate(180deg);
      }
    }

    &:before {
      visibility: hidden;
    }

    svg {
      color: #222222;
      background-color: transparent;
      // width: 38px;
      // height: 38px;
      // @media screen and (max-width: 768px) {
      //   width: 30px;
      //   height: 30px;
      // }
      // &:focus,
      // &:hover,
      // &.active {
      //   opacity: 0.7;
      // }
    }
  `;

  return (
    <span css={BasicArrowStyle} {...props}>
      {children}
    </span>
  );
};

const SlickArrow = ({
  primaryColor,
  secondaryColor,
  uiVariant,
  visualVariants,
  sliderCircleArrowsBanner,

  ...props
}) => {
  return (
    <SlickButtonFix
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      uiVariant={uiVariant}
      props={props}
    >
      <span>
        <Arrow />
      </span>
    </SlickButtonFix>
  );
};

export default SlickArrow;
